<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
  </div>
</template>

<script>
//script
import Tools from "../../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../../scripts/Global";

import QuestionSelect from "../../cmp/questionSelect";

export default {
  data() {
    return {
      data: {
        headTipImg: "苏尚卿讲解",
        headTipTxt: "没关系，我们去下个地方看看吧",
        headTipPathTxt: "前往降雪轩 >>",
        headTipPath: "/rodemap/ssq/03",

        sideImg: "宫女",
        sideCfg: {
          bottom: "-2rem",
          left: "-1.5rem",
          transform: "scale(0.6)"
        },
        qText:
          "糟了糟了，不小心把贵妃纸描的万春亭藻井画弄坏了，你能帮我补救么？",
        errText:
          "糟了糟了，不小心把贵妃纸描的万春亭藻井画弄坏了，你能帮我补救么？",
        // qImg: 'qImg',
        answerArr: [
          {
            txt: "冷眼相待"
          },
          {
            txt: "我可以！",
            right: true
          }
        ]
      }
    };
  },
  components: {
    QuestionSelect
  },
  created() {
    Global.pauseAll();
  },
  computed: {},
  methods: {
    finish(event) {
      if (event) {
      } else {
        this.$router.replace("/rodemap/ssq/06_5");
      }
    },
    jump(event) {
      if (event) {
        this.$router.replace("/rodemap/ssq/07");
      } else {
        // this.$router.replace('/rodemap/ssq/03');
      }
      console.log(event, "event");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/万春亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
